import {get, map, orderBy} from "lodash";
import './SuperAdminCompaniesStats.scss'
import React, {useContext, useEffect, useState} from "react";
import {StatsWidgetWrapper} from "../../../Reports/StatsWidgetWrapper/StatsWidgetWrapper";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import {I18nReactContext} from "../../../../contexts/I18nContext";
import {
    SA_getAllCompaniesWithStatsAPI,
    SA_getAllSystemCompaniesAPI,
    SA_getAllSystemUsersAPI,
} from "../../../../Services/SA_api";
import {i18n} from "../../../../Utils/i18n/i18n";
import {GridReactContextProvider} from "../../../../Utils/DataGridWrapper/GridContext";
import {DataGridWrapper} from "../../../../Utils/DataGridWrapper/DataGridWrapper";
import {format, parseISO} from "date-fns";
import {CopyText} from "../../../../Utils/CopyText/CopyText";
import {Colors} from "../../../../Utils/styles/Colors";

const getColumns = async () => {
    return [
        {
            field: 'companyName',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.companyName"),
            minWidth: 300,
            align: 'right',
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'activeUsers',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.activeUsers"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => {
                const { activeUsers, userQuota } = params.row;
                const backgroundColor = (activeUsers > userQuota) && userQuota && Colors['$themePink'];
                return (
                    <div style={{ width: '100%', borderRadius: '6px', backgroundColor }}>
                        {activeUsers}
                    </div>
                );
            },
        },
        {
            field: 'assignmentCompletion',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.assignmentCompletion"),
            minWidth: 150,
            align: 'right',
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{`${params.value}%`}</div>,
        },
        {
            field: 'lastLoginDate',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.lastAdminLoginDate"),
            minWidth: 200,
            align: 'right',
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{`${params.value ? format(parseISO(params.value), 'dd/MM/yyyy') : ''}`}</div>,
        },
        {
            field: 'adminIdentifier',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.adminIdentifier"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value ? <CopyText text={params.value}/> : ''}</div>,
        },
        {
            field: 'lastMemoSentDate',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.lastMemoSentDate"),
            minWidth: 150,
            align: 'right',
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value ? format(parseISO(params.value), 'dd/MM/yyyy') : ''}</div>,
        },
        {
            field: 'smsCount',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.smsCount"),
            minWidth: 150,
            align: 'right',
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'smsQuota',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.smsQuota"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'userQuota',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.userQuota"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}}>{params.value || "-"}</div>,
        },
        {
            field: 'courses',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.courses"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'organizations',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.organizations"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'admins',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.admins"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'createdAt',
            headerName: i18n.translate("superAdmin.reports.companiesInfo.columns.createdAt"),
            minWidth: 200,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value ? format(params.value, 'dd/MM/yyyy') : ''}</div>,
        },
    ];
}

const convertData = (companiesWithStats) => {
    return map(companiesWithStats, (company) => {
        return {
            ...company,
            lastLoginDate: get(company, 'lastAdminLogin.lastLoginDate'),
            adminIdentifier: get(company, 'lastAdminLogin.identifier')
        }
    })
}
const paginationModel = {
    page: 0,
    pageSize: 25,
};
const getFilterModel = () => {
    return {
        filterValues: {},
        filterData: {},
        showFilters: {
            search: true,
        }
    }
}

export const SuperAdminCompaniesStats = () => {
    const {i18n} = useContext(I18nReactContext);
    const [allSystemActiveUsers, setAllSystemActiveUsers]= useState(0)
    const [thisMonthNewUsers, setThisMonthNewUsers] = useState(0)
    const [allSystemActiveCompanies, setAllSystemActiveCompanies] = useState(0)
    const [thisMonthNewCompanies, setThisMonthNewCompanies] = useState(0)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        init()
    }, [])

    const init = async () => {
        setIsLoading(true)
        const today = new Date();
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const endDate = today;

        const [
            allSystemUsersFromServer,
            thisMonthNewUsersFromServer,
            allSystemCompaniesFromServer,
            thisMonthNewCompaniesFromServer
        ] = await Promise.all([
            SA_getAllSystemUsersAPI({withoutGranularity: true}),
            SA_getAllSystemUsersAPI({startDate, endDate, withoutGranularity: true}),
            SA_getAllSystemCompaniesAPI({withoutGranularity: true}),
            SA_getAllSystemCompaniesAPI({startDate, endDate, withoutGranularity: true})
        ]);

        setAllSystemActiveUsers(get(allSystemUsersFromServer, 'count', 0));
        setThisMonthNewUsers(get(thisMonthNewUsersFromServer, 'count', 0));
        setAllSystemActiveCompanies(get(allSystemCompaniesFromServer, 'count', 0));
        setThisMonthNewCompanies(get(thisMonthNewCompaniesFromServer, 'count', 0));

        setIsLoading(false)
    }


    const apiToGetData = async ({paginationModel, filterModel, sortModel}) => {
        const response = await SA_getAllCompaniesWithStatsAPI({paginationModel, filterModel});

        // Apply client-side sorting if sortModel is provided
        if (sortModel && sortModel.length > 0) {
            const { field, sort } = sortModel[0];
            const sortDirection = sort === 'asc' ? 'asc' : 'desc';

            // Handle special cases for different fields
            let valueGetter;

            switch(field) {
                case 'lastLoginDate':
                    valueGetter = item => get(item, 'lastAdminLogin.lastLoginDate', '');
                    break;

                case 'adminIdentifier':
                    valueGetter = item => get(item, 'lastAdminLogin.identifier', '').toLowerCase();
                    break;

                case 'companyName':
                    valueGetter = item => get(item, field, '').toLowerCase();
                    break;

                default:
                    valueGetter = item => get(item, field);
            }

            // Sort the data
            response.data = orderBy(response.data, [valueGetter], [sortDirection]);
        }

        return response;
    }

    return <div className="SignDocStats">
        {isLoading ? <LoadingSpinner/> : ''}
        <div className="row numberWidgetsRow">
            <div className="col-50 margin-left row">
                <div className="col-50 margin-left">
                    <StatsWidgetWrapper
                        bottomTitle={i18n.translate(`superAdmin.reports.companiesInfo.totalUsersCount`)}>
                        <div className="counter">
                            {allSystemActiveUsers}
                        </div>
                    </StatsWidgetWrapper>
                </div>
                <div className="col-50">
                    <StatsWidgetWrapper
                        bottomTitle={i18n.translate(`superAdmin.reports.companiesInfo.newUsersThisMonthCount`)}>
                        <div className="counter">
                            {thisMonthNewUsers}
                        </div>
                    </StatsWidgetWrapper>
                </div>
            </div>
            <div className="col-50 margin-right row">
                <div className="col-50 margin-left">
                    <StatsWidgetWrapper
                        bottomTitle={i18n.translate(`superAdmin.reports.companiesInfo.totalCompaniesCount`)}>
                        <div className="counter">
                            {allSystemActiveCompanies}
                        </div>
                    </StatsWidgetWrapper>
                </div>
                <div className="col-50">
                    <StatsWidgetWrapper
                        bottomTitle={i18n.translate(`superAdmin.reports.companiesInfo.newCompaniesThisMonthCount`)}>
                        <div className="counter">
                            {thisMonthNewCompanies}
                        </div>
                    </StatsWidgetWrapper>
                </div>
            </div>
        </div>
        <div className="allItemsWrapper SuperAdminPage">
            <GridReactContextProvider>
                <DataGridWrapper
                    filterModel={getFilterModel()}
                    disableColumnFilter
                    getColumns={getColumns}
                    paginationModel={paginationModel}
                    apiToGetData={apiToGetData}
                    dataConverter={convertData}
                />
            </GridReactContextProvider>
        </div>
    </div>
    }